import {selectGameResults} from '../../redux/reducers/sharedStateReducer/selectors';

/**
 * Партия окончена: подведены итоги либо миссия закончилась по заданиям (итогов
 * партии там нет, только окно миссии). Указатель хода при этом остается на
 * последнем игроке, но ход больше ничей.
 * Защитно: состояния, собранные вручную, могут не содержать среза миссии
 */
export const checkIfMatchOver = (state) => Boolean(
  selectGameResults(state) || state.private?.mission?.isMissionCompleted
);
